import { useState } from "react";

export const useLayoutSettings = () => {
  const [isParamsOpen, setIsParamsOpen] = useState(true);
  const [isPreviewFull, setIsPreviewFull] = useState(false);

  return {
    params: {
      isOpen: isParamsOpen,
      toggle: () => setIsParamsOpen((prev) => !prev),
    },
    preview: {
      isFullView: isPreviewFull,
      toggle: () => setIsPreviewFull((prev) => !prev),
    },
  };
};
